import { Divider, View } from '@gluestack-ui/themed'
import { isEmpty } from 'lodash'
import React, { FunctionComponent } from 'react'
import { useSelector } from 'react-redux'
import { MansoryItemResult } from '../../../api/Favorites/types'
import { ReferentielMediaResult } from '../../../api/Referentiels/types'
import { themeSelector } from '../../../redux/theme/selector'
import { openLink } from '../../../services/browserInApp'
import { getBubble } from '../../../services/bubble'
import { theme as defaultTheme } from '../../../theme'
import { SvgXTwitterLogo } from '../../Logos'
import { MasonryList } from '../../MasonryList'

interface ReferentielSocialNetworksProps {
  socialNetworks?: ReferentielMediaResult | null
  colums?: number
}

interface ReferentielSocialNetworkItem extends MansoryItemResult {
  component: React.ReactNode
}

export const ReferentielSocialNetworks: FunctionComponent<ReferentielSocialNetworksProps> = ({ socialNetworks, colums }) => {
  const items: ReferentielSocialNetworkItem[] = []

  const addItem = (component: React.ReactNode) => {
    items.push({
      id: items.length + 1,
      sizeX: 1,
      component,
    })
  }

  if (socialNetworks) {
    if (socialNetworks.facebook) {
      const fb = socialNetworks.facebook
      addItem(
        getBubble({
          link: {
            icon: 'facebook',
            iconTheme: 'FontAwesome',
            label: 'Facebook',
          },
          onPress: () => openLink(fb),
        }),
      )
    }

    if (socialNetworks.x) {
      const { x } = socialNetworks
      const theme = useSelector(themeSelector)
      const color = theme ? theme.brandPrimary : defaultTheme.bubble.color
      addItem(
        getBubble({
          link: {
            icon: <SvgXTwitterLogo color={color} size={16} accessibilityLabel="X Twitter Logo" />,
            label: 'X',
          },
          onPress: () => openLink(x),
        }),
      )
    }

    if (socialNetworks.instagram) {
      const { instagram } = socialNetworks
      addItem(
        getBubble({
          link: {
            icon: 'instagram',
            iconTheme: 'FontAwesome',
            label: 'Instagram',
          },
          onPress: () => openLink(instagram),
        }),
      )
    }

    if (socialNetworks.linkedIn) {
      const { linkedIn } = socialNetworks
      addItem(
        getBubble({
          link: {
            icon: 'linkedin',
            iconTheme: 'FontAwesome',
            label: 'LinkedIn',
          },
          onPress: () => openLink(linkedIn),
        }),
      )
    }

    if (socialNetworks.tikTok) {
      const { tikTok } = socialNetworks
      addItem(
        getBubble({
          link: {
            icon: 'tiktok',
            iconTheme: 'FontAwesome5',
            label: 'TikTok',
          },
          onPress: () => openLink(tikTok),
        }),
      )
    }
  }

  if (isEmpty(items)) {
    return null
  }

  return (
    <>
      {/* eslint-disable-next-line react-native/no-inline-styles */}
      <View style={{ marginVertical: 10 }}>
        <MasonryList<ReferentielSocialNetworkItem>
          data={items}
          columns={colums || items.length || 4}
          columnHeight={80}
          columnJustify="flex-start"
          renderItem={(item: ReferentielSocialNetworkItem) => item.component}
        />
      </View>
      <Divider />
    </>
  )
}
